import SendTopup from "./SendTopup";

/**
 * Gift Cards — reuses the SendTopup form, filtered to the "giftcards"
 * catalog category so only Amazon / Netflix / voucher-style products
 * from DingConnect and Reloadly surface.
 *
 * Countries + operators + products are ALL filtered server-side by the
 * `category=giftcards` query parameter so the dropdowns stay short and
 * relevant. If the user's DingConnect / Reloadly account doesn't yet
 * carry any gift-card products, the country list is simply empty —
 * agents see "No countries available" instead of a confusing empty
 * operator dropdown.
 */
export default function GiftCards() {
  return (
    <SendTopup
      category="giftcards"
      pageTitle="Gift Cards"
      pageSubtitle="Envoyer des cartes cadeaux (Amazon, Netflix, vouchers digitaux…)."
    />
  );
}
